/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import {  Col, Form, Input, Row, Select, } from "antd";
import {
  isEditEspWorkflowByStatus,
  listEspWorkFlowStatusTabReview,
} from "../../../utils/helper";
import { IApWorkflowCommentHistory, IDataEspWorkflowDetail } from "../../../interfaces/workflow";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../constants/common";
import { PERMISSIONS } from "../../../constants/permission";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { MASTERDATA_TYPE } from "../../../constants/master-data";
import { useMasterData } from "../../../hooks/useMasterData";
import { EspWorkflowStatusEnum, matchedFlagOptions, espWorkflowTeamOptions } from "../../../constants/ap-workflow";

const { TextArea } = Input;

interface TourEventOtherMatchingSetFormProps {
  form: any;
  comments: IApWorkflowCommentHistory[];
  matchingDetail: IDataEspWorkflowDetail;
}

const TourEventOtherMatchingSetForm: React.FC<TourEventOtherMatchingSetFormProps> = ({
  form,
  comments = [],
  matchingDetail,
}) => {
  const { status } = matchingDetail;

  const hasEditor = useHasPermission([PERMISSIONS.WORKFLOW_EDITOR]);
  const isDisabledField = !hasEditor || !isEditEspWorkflowByStatus(status);
  
  const types = useMemo(
    () => [
      MASTERDATA_TYPE.NOMINAL_ACCOUNT_CREDIT,
      MASTERDATA_TYPE.NOMINAL_ACCOUNT_DEBIT,
      MASTERDATA_TYPE.UNDERS_OVERS_AUTO_MATCH,
    ],
    []
  );

  const { data: masterData } = useMasterData({
    types,
  });

  const { nominalAccountCredits = [], nominalAccountDebits = [], underOverAutoMatches = [] } = masterData;

  const isNominalCode = useMemo(
    () => [EspWorkflowStatusEnum.EXPORTED, EspWorkflowStatusEnum.COMPLETED].includes(status),
    [status]
  );

  const renderComments = () => (
    <ul className="box-comment">
      {comments.map((item) => (
        <li key={item.id}>
          <div className="text">{item.comment}</div>
          <div className="time">
            {dayjs(item.updatedAt).format(`HH:mm ${DATE_FORMAT}`)} - by {item.userName}
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <Form form={form} layout="vertical" disabled={isDisabledField}>
        <h4 className="sub-title">Actions</h4>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Assign Team" name="team">
              <Select
                options={espWorkflowTeamOptions}
                placeholder="Choose Team"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Add Flag" name="flag">
              <Select
                options={matchedFlagOptions}
                placeholder="Select Flag"
                mode="multiple"
                maxCount={3}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Update Status" name="status">
              <Select
                options={listEspWorkFlowStatusTabReview.map((item: string) => ({
                  value: item.toString(),
                  label: item,
                }))}
                placeholder="Choose Status"
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <h4 className="sub-title">Nominal Codes</h4>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Credit" name="credit">
              <Select
                options={nominalAccountCredits.map((item: any) => ({
                  value: item.code,
                  label: item.label,
                }))}
                placeholder="Choose Credit"
                disabled={isNominalCode}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Debit" name="debit">
              <Select
                options={nominalAccountDebits.map((item: any) => ({
                  value: item.code,
                  label: item.label,
                }))}
                placeholder="Choose Debit"
                disabled={isNominalCode}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Unders & Overs" name="underOver">
              <Select
                options={underOverAutoMatches.map((item: any) => ({
                  value: item.code,
                  label: item.label,
                }))}
                placeholder="Choose Unders & Overs"
                disabled={isNominalCode}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={3}>Comments</Col>
          <Col span={21}>
            <Form.Item label={null} name="comment">
              <TextArea placeholder="Add comment here" autoSize={{ minRows: 2 }} disabled={!hasEditor} />
            </Form.Item>
            {comments.length > 0 && renderComments()}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default TourEventOtherMatchingSetForm;
